import { render } from "./EditCallback.vue?vue&type=template&id=2f543a9c"
import script from "./EditCallback.vue?vue&type=script&lang=ts"
export * from "./EditCallback.vue?vue&type=script&lang=ts"
script.render = render

export default script